var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAllDirections20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    id: "mi-arrow-all-directions",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48 1.331A1 1 0 0 1 9.222 1h1.554a1 1 0 0 1 .744.331l2.1 2.335-.743.668L10.778 2H10.5v6h-1V2h-.277L7.122 4.334l-.744-.668L8.48 1.33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5v-.277l-2.335-2.101.67-.744 2.334 2.101a1 1 0 0 1 .331.744v1.554a1 1 0 0 1-.331.744l-2.335 2.1-.668-.743 2.334-2.1V10.5h-6v-1h6zM10.5 12v6h.277l2.101-2.335.744.67-2.101 2.334a1 1 0 0 1-.744.331H9.223a1 1 0 0 1-.744-.331l-2.1-2.335.743-.668L9.222 18H9.5v-6h1zM2 10.5v.277l2.334 2.101-.668.744L1.33 11.52A1 1 0 0 1 1 10.777V9.223a1 1 0 0 1 .331-.744l2.335-2.1.668.743L2 9.222V9.5h6v1H2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAllDirections20Px);
export default __webpack_public_path__ + "static/media/arrow-all-directions-20px.5c097e988c1b1f278b26118d87cd17b6.svg";
export { ForwardRef as ReactComponent };